import * as log from "loglevel";
import {times, head, last, forEach} from 'lodash';
import {levelGroup} from "../Level";
import {game} from "../../GameCore";
import {gameConfig} from "../../config/GameConfig";

export var groundSprite: Phaser.Sprite;
export var groundSprites: Phaser.Sprite[];


/**
 * create the floor for the game
 */
export function createGround()
{
    var tiles_needed: number;

    //  how many tiles to we need to completely cover the world floor?

    tiles_needed = Math.ceil(game.world.width / gameConfig.tileWidth) + 1;

    //  create all the tiles we need

    coverGroundWithTiles(tiles_needed);
}


/**
 * create as many tiles as we need to cover the floor of the world
 * @param tiles_needed
 */
function coverGroundWithTiles(tiles_needed: number)
{
    var sprite: Phaser.Sprite;

    groundSprites = times(tiles_needed, (i: number) =>
    {
        //  create a sprite

        sprite = game.add.sprite(gameConfig.tileWidth * i, getTileY(), 'sprites', 'tile');

        //  enable physics on the sprite

        game.physics.arcade.enable(sprite);

        //  set sprite physics properties

        sprite.body.immovable = true;
        sprite.body.allowGravity = false;
        sprite.body.collideWorldBounds = false;
        sprite.alpha = 0;

        levelGroup.addChild(sprite);

        //  return the sprite

        return sprite;
    });
}


/**
 * update the floor tiles on tick;
 * move tiles from the back of the queue to the front, and change their texture if needed
 */
export function updateGround()
{
    var sprite: Phaser.Sprite;

    //  get the first tile in the list

    sprite = head(groundSprites);

    //  if it's entirely on screen don't do anything else

    if (sprite.body.x > gameConfig.tileWidth * -1) return;

    // log.debug('killing sprite');

    //  if it's off-screen then let's recycle it

    sprite.reset(
        last(groundSprites).x + gameConfig.tileWidth,
        //Math.floor(groundSprites.length * gameConfig.tileWidth - levelGroup.x - gameConfig.tileWidth),
        getTileY()
    );

    //  move the first element to the back of the list

    groundSprites.push(groundSprites.shift());
}



/**
 * reset and rebuild
 */
export function resetGround()
{
    //  remove all ground tile sprites

    forEach(groundSprites, (sprite: Phaser.Sprite) =>
    {
        sprite.kill();
    });
}


/**
 * get the y position for floor tiles
 */
function getTileY() : number
{
    return game.world.height - gameConfig.tileWidth;
}


// WEBPACK FOOTER //
// ./src/ts/game/level/ground/Ground.ts